import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

/** Switches the activity page between the team's sessions and only your own. */
export default function ActivityScopeSwitch({
  personal,
  onChange,
}: {
  personal: boolean;
  onChange: (personal: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t("activity.scope")}
      className="flex h-[38px] items-center gap-0.5 rounded-lg border border-outline bg-surface p-0.5"
    >
      {[false, true].map(option => (
        <button
          key={String(option)}
          type="button"
          aria-pressed={personal === option}
          onClick={() => onChange(option)}
          className={clsx(
            "h-full rounded-md px-3 text-sm font-medium transition-colors focus-visible:outline-info",
            personal === option ? "bg-muted-surface text-text" : "text-text-mid hover:text-text",
          )}
        >
          {t(option ? "activity.scope_only_you" : "activity.scope_team")}
        </button>
      ))}
    </div>
  );
}
